import { render, staticRenderFns } from "./CommonPopup.vue?vue&type=template&id=5ddf7458&"
import script from "./CommonPopup.vue?vue&type=script&lang=ts&"
export * from "./CommonPopup.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports